<template>
  <el-select
    :loading="loading"
    :value="value"
    :placeholder="placeholder"
    v-bind="$attrs"
    @change="typeChange"
  >
    <el-option
      v-for="item in list"
      :key="item.dictionaryId"
      :value="item.dictionaryId"
      :label="item.dictionaryName"
    />
  </el-select>
</template>

<script>
import { listByTypeCode } from '@/api/user'
import { dispatch } from '@/utils/agreementUtil'
import { companyManagerType } from '@/api/personnel'
export default {
  name: 'DictionarySelect',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    dictionaryTypeCode: {
      type: String,
      default: ''
    },
    agreementCode: {
      type: String,
      default: ''
    },
    isPost: {
      type: Boolean,
      default: true
    },
    companyId: {
      type: String,
      default: ''
    },
    isNotMonth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      list: []
    }
  },
  created() {
    if (this.isPost) {
      this.getData()
    }
  },
  methods: {
    getData() {
      this.loading = true
      let method = listByTypeCode
      if (this.companyId && this.agreementCode) {
        method = companyManagerType
      }
      method({
        projectId: this.$store.state.user.projectItem.projectId,
        dictionaryTypeCode: this.dictionaryTypeCode,
        agreementCode: this.agreementCode,
        companyId: this.companyId
      })
        .then((res) => {
          if (this.isNotMonth) {
            res.data = res.data.filter((item) => item.dictionaryCode !== '003')
          }
          this.list = res.data
          console.log('isNotMonth', this.isNotMonth)

          if (res.data.length > 0) {
            if (this.dictionaryTypeCode === 'byq_zjlx') {
              const item = res.data.find((item) => {
                if (item.dictionaryCode === '01') {
                  return true
                }
              })
              if (item) {
                this.$emit('getDataSuccess', item.dictionaryId, res.data)
              } else {
                this.$emit('getDataSuccess', res.data[0].dictionaryId, res.data)
              }
            } else {
              this.$emit('getDataSuccess', res.data[0].dictionaryId, res.data)
            }
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    typeChange(e) {
      this.$emit('input', e)
      dispatch.call(this, 'ElFormItem', 'el.form.blur', [e])
      const item = this.list.find((item) => item.dictionaryId === e)
      this.$emit('change', item)
    }
  }
}
</script>

<style scoped>
.HeaderForm {
  background: #fff;
  padding-top: 10px;
}
.flexEnd {
  display: flex;
  justify-content: flex-end;
}
</style>
